export class InvalidConfigurationContextError extends Error {
  public name = 'InvalidConfigurationContextError';
}
